import {
  therapyPlanningAction,
  patientDateOfServiceConstant,
  newTherapyTemplateAction,
} from './constant';

const { GET_PATIENT_DATE_OF_SERVICE_REQUEST } = patientDateOfServiceConstant;
const {
  GET_ASSESSMENT_REQUEST,
  GET_MDS_ASSESSMENT_REQUEST,
  GET_PLAN_OF_CARE_REQUEST,
  CREATE_ASSESSMENT_REQUEST,
  UPDATE_ASSESSMENT_REQUEST,
  RESET_CREATE_ASSESSMENT,
  RESET_UPDATE_ASSESMENT,
  GET_THERAPY_PLANNING_REQUEST,
  GET_THERAPY_PLANNING_LOADING,
  UPDATE_THERAPY_PLANNING_REQUEST,
  RESET_UPDATE_THERAPY_PLANNING_REQUEST,
  GET_PATIENT_THERAPY_PLANNING_REQUEST,
  GET_CPT_CODE_BY_DISCIPLINE_REQUEST,
  EDIT_AUTHORIZATION_PLANNING_REQUEST,
  EDIT_AUTHORIZATION_PLANNING_RESET,
  UPDATE_THERAPY_PLANNING_DISCHARGE_DATE_REQUEST,
  RESET_THERAPY_PLANNING_DISCHARGE_DATE_REQUEST,
  GET_AUTHORIZATION_DETAILS_REQUEST,
  GET_CASE_MIX_GROUP_REQUEST,
  GET_PATIENT_THERAPY_PLANNING_RESET,
  GET_MULTIPLE_MDS_ASSESSMENT_REQUEST,
  GET_THERAPY_PLANNING_PATIENT_REQUEST,
  REQUEST_VALIDATE_MDS_CSV_TEMPLATE,
  REQUEST_UPLOAD_MDS_CSV_TEMPLATE,
  RESET_VALIDATE_MDS_CSV_TEMPLATE,
  RESET_UPLOAD_MDS_CSV_TEMPLATE,
  GET_PATIENT_THERAPY_PLANNING_RESET_2_0,
  CHECK_THERAPY_PLANNING_PLAN_MINUTES_REQUEST,
  GET_PATIENT_THERAPY_PLANNING_REQUEST_2_0,
  CHECK_THERAPY_PLANNING_PLAN_MINUTES_RESET,
  GET_DATA_THERAPY_PLANNING_REQUEST_2_0,
  GET_THERAPY_PLANNING_SUMMARY_REQUEST_2_0,
  EDIT_SINGLE_CELL_THERAPY_PLANNING_REQUEST,
  EDIT_SINGLE_CELL_THERAPY_PLANNING_RESET,
  UPDATE_UNCOVERED_DAY_THERAPY_PLANNING_REQUEST,
  GET_THERAPY_PLANNING_DISCHARGE_REQUEST_2_0,
  COPY_PASTE_THERAPY_PLANNING_REQUEST_2_0,
  COPY_PASTE_THERAPY_PLANNING_RESET_2_0,
  APPLY_THERAPY_TEMPLATES_REQUEST_2_0,
  APPLY_THERAPY_TEMPLATES_RESET_2_0,
  GET_ALL_THERAPY_TEMPLATES_REQUEST_2_0,
  GET_ALL_THERAPY_TEMPLATES_RESET_2_0,
  APPLY_SELECTED_TEMPLATES_REQUEST_2_0,
  APPLY_SELECTED_TEMPLATES_RESET_2_0,
  GET_MDS_ASSESSMENT_RANGE_REQUEST,
  GET_SINGLE_MDS_ASSESSMENT_REQUEST,
  GET_SINGLE_MDS_ASSESSMENT_RESET,
  DELETE_MDS_ASSESSMENT_BY_DATE_REQUEST,
  DELETE_MDS_ASSESSMENT_BY_DATE_RESET,
  DELETE_SINGLE_MDS_ASSESSMENT_BY_REQUEST,
  DELETE_SINGLE_MDS_ASSESSMENT_BY_RESET,
  GET_7DAY_LOOK_BACK_SUM_REQUEST,
} = therapyPlanningAction;

const {
  CREATE_NEW_THERAPY_TEMPLATE_REQUEST,
  CREATE_NEW_THERAPY_TEMPLATE_RESET,
  DELETE_THERAPY_TEMPLATE_REQUEST,
  DELETE_THERAPY_TEMPLATE_RESET,
  EDIT_THERAPY_TEMPLATE_REQUEST,
  EDIT_THERAPY_TEMPLATE_RESET,
} = newTherapyTemplateAction;

export const updateTherapyPlanningDischargeDate = (payload: any) => {
  return {
    type: UPDATE_THERAPY_PLANNING_DISCHARGE_DATE_REQUEST,
    payload,
  };
};

export const resetTherapyPlanningDischargeDate = () => {
  return {
    type: RESET_THERAPY_PLANNING_DISCHARGE_DATE_REQUEST,
  };
};

export const getTherapyPlanning = (payload: any) => {
  return {
    type: GET_THERAPY_PLANNING_REQUEST,
    payload,
  };
};

export const checkTherapyPlanning = (payload: any) => {
  return {
    type: CHECK_THERAPY_PLANNING_PLAN_MINUTES_REQUEST,
    payload,
  };
};

export const resetCheckTherapyPlanning = () => {
  return {
    type: CHECK_THERAPY_PLANNING_PLAN_MINUTES_RESET,
  };
};

export const isTherapyPlanningPatient = (payload: any) => {
  return {
    type: GET_THERAPY_PLANNING_PATIENT_REQUEST,
    payload,
  };
};

export const resetTherapyPlanning = () => {
  return {
    type: GET_PATIENT_THERAPY_PLANNING_RESET,
  };
};

export const getTherapyPlanningLoading = () => {
  return {
    type: GET_THERAPY_PLANNING_LOADING,
  };
};

export const getPatientDateOfService = (payload: any) => {
  return {
    type: GET_PATIENT_DATE_OF_SERVICE_REQUEST,
    payload,
  };
};
export const getTherapyPlanningPatient = (payload: any) => {
  return {
    type: GET_PATIENT_THERAPY_PLANNING_REQUEST,
    payload,
  };
};
export const updateTherapyPlanning = (payload: any) => {
  return {
    type: UPDATE_THERAPY_PLANNING_REQUEST,
    payload,
  };
};
export const resetUpdateTherapyPlanning = () => {
  return {
    type: RESET_UPDATE_THERAPY_PLANNING_REQUEST,
  };
};
export const getMdsAssessment = (payload: any) => {
  return {
    type: GET_MDS_ASSESSMENT_REQUEST,
    payload,
  };
};
export const getAssessment = (payload: any) => {
  return {
    type: GET_ASSESSMENT_REQUEST,
    payload,
  };
};
export const getPlanOfCare = (payload: any) => {
  return {
    type: GET_PLAN_OF_CARE_REQUEST,
    payload,
  };
};
export const createAssessment = (payload: any) => {
  return {
    type: CREATE_ASSESSMENT_REQUEST,
    payload,
  };
};
export const updateAssessment = (payload: any) => {
  return {
    type: UPDATE_ASSESSMENT_REQUEST,
    payload,
  };
};
export const resetCreateAssessment = () => {
  return {
    type: RESET_CREATE_ASSESSMENT,
  };
};
export const resetUpdateAssessment = () => {
  return {
    type: RESET_UPDATE_ASSESMENT,
  };
};

export const getCptCodeByDisciplineAction = (payload: any) => {
  return {
    type: GET_CPT_CODE_BY_DISCIPLINE_REQUEST,
    payload,
  };
};

export const editAuthorizationAction = (payload: any) => {
  return {
    type: EDIT_AUTHORIZATION_PLANNING_REQUEST,
    payload,
  };
};

export const editAuthorizationResetAction = () => {
  return {
    type: EDIT_AUTHORIZATION_PLANNING_RESET,
  };
};

export const getAuthorizationDetails = (payload: any) => {
  return {
    type: GET_AUTHORIZATION_DETAILS_REQUEST,
    payload,
  };
};

export const getCaseMixGroup = () => {
  return {
    type: GET_CASE_MIX_GROUP_REQUEST,
  };
};

export const getMultipleMDAAssessment = (payload: any) => {
  return {
    type: GET_MULTIPLE_MDS_ASSESSMENT_REQUEST,
    payload,
  };
};

//mds assessment bulk upload
export const getValidationCSVTemplateOfMds = (payload: any) => {
  return {
    type: REQUEST_VALIDATE_MDS_CSV_TEMPLATE,
    payload,
  };
};

export const getValidationCSVTemplateOfMdsReset = () => {
  return {
    type: RESET_VALIDATE_MDS_CSV_TEMPLATE,
  };
};

export const uploadCSVTemplateOfMds = (payload: any) => {
  return {
    type: REQUEST_UPLOAD_MDS_CSV_TEMPLATE,
    payload,
  };
};

export const uploadCSVTemplateOfMdsReset = () => {
  return {
    type: RESET_UPLOAD_MDS_CSV_TEMPLATE,
  };
};

export const getTherapyPlanningPatient_2_0 = (payload: any) => {
  return {
    type: GET_PATIENT_THERAPY_PLANNING_REQUEST_2_0,
    payload,
  };
};

export const resetGetTherapyPlanningPatient_2_0 = () => {
  return {
    type: GET_PATIENT_THERAPY_PLANNING_RESET_2_0,
  };
};

export const getTherapyPlanningData_2_0 = (payload: any) => {
  return {
    type: GET_DATA_THERAPY_PLANNING_REQUEST_2_0,
    payload,
  };
};

export const getTherapyPlanningSummary_2_0 = (payload: any) => {
  return {
    type: GET_THERAPY_PLANNING_SUMMARY_REQUEST_2_0,
    payload,
  };
};

export const editSingleCellOfTherapyPlanningAction = (payload: any) => {
  return {
    type: EDIT_SINGLE_CELL_THERAPY_PLANNING_REQUEST,
    payload,
  };
};

export const updateUncoveredDayTherapyPlanning_2_0Action = (payload: any) => {
  return {
    type: UPDATE_UNCOVERED_DAY_THERAPY_PLANNING_REQUEST,
    payload,
  };
};

export const resetSingleCellReducer = () => {
  return {
    type: EDIT_SINGLE_CELL_THERAPY_PLANNING_RESET,
  };
};

export const getDischargeDatesOfTherapyPlanning2_0 = (payload: any) => {
  return {
    type: GET_THERAPY_PLANNING_DISCHARGE_REQUEST_2_0,
    payload,
  };
};

export const copyTherapyWeekAction = (payload: any) => {
  return {
    type: COPY_PASTE_THERAPY_PLANNING_REQUEST_2_0,
    payload,
  };
};

export const copyTherapyWeekActionRest = () => {
  return {
    type: COPY_PASTE_THERAPY_PLANNING_RESET_2_0,
  };
};

export const saveTherapyTemplatesAction = (payload: any) => {
  return {
    type: APPLY_THERAPY_TEMPLATES_REQUEST_2_0,
    payload,
  };
};

export const getAllTherapyPlanningTemplates = (payload: any) => {
  return {
    type: GET_ALL_THERAPY_TEMPLATES_REQUEST_2_0,
    payload,
  };
};

export const resetGetAllTherapyTemplates = () => {
  return {
    type: GET_ALL_THERAPY_TEMPLATES_RESET_2_0,
  };
};

export const applySelectedTemplateAction = (payload: any) => {
  return {
    type: APPLY_SELECTED_TEMPLATES_REQUEST_2_0,
    payload,
  };
};

export const resetApplySelectedTherapyTemplate = () => {
  return {
    type: APPLY_SELECTED_TEMPLATES_RESET_2_0,
  };
};

export const resetTherapyTemplatesAction = () => {
  return {
    type: APPLY_THERAPY_TEMPLATES_RESET_2_0,
  };
};

export const createNewTherapyTemplateAction = (payload: any) => {
  return {
    type: CREATE_NEW_THERAPY_TEMPLATE_REQUEST,
    payload,
  };
};

export const resetcreateNewTherapyTemplateAction = () => {
  return {
    type: CREATE_NEW_THERAPY_TEMPLATE_RESET,
  };
};

export const deleteTherapyTemplateAction = (payload: any) => {
  return {
    type: DELETE_THERAPY_TEMPLATE_REQUEST,
    payload,
  };
};

export const resetDeleteTherapyTemplateAction = () => {
  return {
    type: DELETE_THERAPY_TEMPLATE_RESET,
  };
};

export const editTherapyTemplateAction = (payload: any) => {
  return {
    type: EDIT_THERAPY_TEMPLATE_REQUEST,
    payload,
  };
};

export const resetEditTherapyTemplateAction = () => {
  return {
    type: EDIT_THERAPY_TEMPLATE_RESET,
  };
};

export const getTherapyPlanningRangeAction = (payload: any) => {
  return {
    type: GET_MDS_ASSESSMENT_RANGE_REQUEST,
    payload,
  };
};

export const getSingleMdsAssessmentAction = (payload: any) => {
  return {
    type: GET_SINGLE_MDS_ASSESSMENT_REQUEST,
    payload,
  };
};

export const resetGetSingleMdsAssessment = () => {
  return {
    type: GET_SINGLE_MDS_ASSESSMENT_RESET,
  };
};


export const deleteMdsAssessmentByDate = (payload: any) => {
  return {
    type: DELETE_MDS_ASSESSMENT_BY_DATE_REQUEST,
    payload,
  };
};

export const resetDeleteMdsAssessmentByDate = () => {
  return {
    type: DELETE_MDS_ASSESSMENT_BY_DATE_RESET,
  };
};

export const deleteSingleMdsAssessment = (payload: any) => {
  return {
    type: DELETE_SINGLE_MDS_ASSESSMENT_BY_REQUEST,
    payload,
  };
};

export const resetDeleteSingleMdsAssessment = () => {
  return {
    type: DELETE_SINGLE_MDS_ASSESSMENT_BY_RESET,
  };
};

export const get7DayLookBack = (payload: any) => {
  return {
    type: GET_7DAY_LOOK_BACK_SUM_REQUEST,
    payload,
  };
};